// Styles
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides

import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

import { createVuetify } from 'vuetify'

export default createVuetify({
    theme: {
      defaultTheme: "light",
    }
  }
)
